export function attachAuthenticationTokenToRequests(axios, token, condition = () => true) {
    axios.interceptors.request.use(async (request) => {
        if (!request.flags?.disableBearerAuthentication && condition(request)) {
            request.headers.Authorization = await token();
        }
        return request;
    }, (err) => Promise.reject(err.response));
}
